import camelcaseKeys from 'camelcase-keys';

import type { FuscaFleetShippingInfo, UUID } from '@cobliteam/common-types';

import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { Configuration } from '../../request/Types';

export class FuscaFleetRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public getFleetInfo = async (
    fleetId: UUID
  ): Promise<FuscaFleetShippingInfo> => {
    const requestData = {
      endpoint: `/fleets/${fleetId}/`,
      method: HttpMethod.GET,
    };

    const response = await this.requester.request(requestData);

    const data = camelcaseKeys(response.data, { deep: true });

    const fleetInfo: FuscaFleetShippingInfo = {
      address: data.shipping?.address,
      contactEmail: data.shipping?.contactEmail,
      contactPhone: data.shipping?.contactPhone,
    };

    return fleetInfo;
  };

  public updateFleetInfo = async (
    fleetId: UUID,
    fleetInfo: FuscaFleetShippingInfo
  ) => {
    const requestData = {
      endpoint: `/fleets/${fleetId}/shipping/`,
      method: HttpMethod.PUT,
      body: JSON.stringify({
        address: fleetInfo.address,
        contact_email: fleetInfo.contactEmail,
        contact_phone: fleetInfo.contactPhone,
      }),
    };

    await this.requester.request(requestData);
  };
}

export default FuscaFleetRequester;
